(function () {
  'use strict';

  /* @ngdoc object
   * @name orders.delete
   * @description
   *
   */
  angular
    .module('orders.delete', [
      'ui.router'
    ]);
}());
